import { createSlice } from '@reduxjs/toolkit';
import {
    fetchEntries,
    addEntry,
    getEntryById,
    editEntry,
    deleteEntry
} from '../actions/operationalLogEntry';

export const operationalLogEntrySlice = createSlice({
    name: 'operationalLogEntry',
    initialState: {
        loading: false,
        data: [],
        addedEntry: null,
        entryToEdit: null,
        entryToEditLoading: false,
        editedEntry: null
    },
    reducers: {
        resetOperationalLogEntries: (state) => {
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // FETCH ENTRIES
            .addCase(fetchEntries.pending, (state) => { state.loading = true })
            .addCase(fetchEntries.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchEntries.rejected, (state) => { state.loading = false })
            // ADD ENTRY
            .addCase(addEntry.pending, (state) => { state.loading = true })
            .addCase(addEntry.fulfilled, (state, action) => {
                state.loading = false;
                state.addedEntry = action.payload;
            })
            .addCase(addEntry.rejected, (state) => { state.loading = false })
            // GET ENTRY BY ID
            .addCase(getEntryById.pending, (state) => { state.entryToEditLoading = true })
            .addCase(getEntryById.fulfilled, (state, action) => {
                state.entryToEditLoading = false;
                state.entryToEdit = action.payload;
            })
            .addCase(getEntryById.rejected, (state) => { state.entryToEditLoading = false })
            // EDIT ENTRY
            .addCase(editEntry.pending, (state) => { state.entryToEditLoading = true })
            .addCase(editEntry.fulfilled, (state, action) => {
                state.entryToEditLoading = false;
                state.editedEntry = action.payload;
            })
            .addCase(editEntry.rejected, (state) => { state.entryToEditLoading = false })
            // DELETE ENTRY
            .addCase(deleteEntry.pending, (state) => { state.loading = true })
            .addCase(deleteEntry.fulfilled, (state) => { state.loading = false })
            .addCase(deleteEntry.rejected, (state) => { state.loading = false });
    }
});

export const { resetOperationalLogEntries } = operationalLogEntrySlice.actions;
export default operationalLogEntrySlice.reducer;
